import { DownloadOutlined, InfoCircleOutlined } from '@ant-design/icons'
import React from 'react'
import { useDownloadCensusTemplate } from '../../hooks/useDownloadCensusTemplate'
import styles from './DownloadCensusTemplate.module.scss'

const CensusTemplateBanner = () => {
  const { isLoading, downloadTemplate } = useDownloadCensusTemplate()

  const renderLink = (label: string) => (
    <button
      type="button"
      className={styles.link}
      onClick={downloadTemplate}
      disabled={isLoading}
      aria-busy={isLoading}
    >
      {label}
      <DownloadOutlined style={{ marginLeft: '2px' }} />
    </button>
  )

  return (
    <div className={styles.banner} role="note">
      <InfoCircleOutlined className={styles.bannerIcon} aria-hidden="true" />
      <span>
        Preparing a census file? Start with the{' '}
        {renderLink('census upload template')} and follow the{' '}
        <span style={{ color: '#00a0a8', fontWeight: 'bold' }}>
          instructions
        </span>
        .
      </span>
    </div>
  )
}

export default CensusTemplateBanner
